import React from 'react';
import { LucideIcon } from 'lucide-react';
import './PageHeader.css';

interface PageHeaderProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ icon: Icon, title, subtitle, actions }) => {
  return (
    <div className="page-header">
      <div className="header-content">
        <div className="header-icon-wrapper">
          <Icon className="header-icon" />
        </div>
        <div>
          <h1 className="page-title">{title}</h1>
          <p className="page-subtitle">{subtitle}</p>
        </div>
      </div>
      {actions && (
        <div className="header-actions">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;

